export function setupPWATracking(gtag) {
  const today = new Date().toISOString().split('T')[0]
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true

  // Track app installation
  if (isStandalone && !localStorage.getItem('pwa_installed_once')) {
    gtag.event('pwa_installed', {
      event_category: 'PWA',
      event_label: 'mobile'
    })
    localStorage.setItem('pwa_installed_once', 'true')
  }

  // Track daily usage
  if (localStorage.getItem('pwa_opened_date') !== today) {
    gtag.event('pwa_opened', {
      event_category: 'PWA',
      event_label: isStandalone ? 'standalone' : 'browser'
    })
    localStorage.setItem('pwa_opened_date', today)
  }

  // Track install prompt
  window.addEventListener('beforeinstallprompt', (e) => {
    gtag.event('pwa_install_prompt_shown', {
      event_category: 'PWA',
      event_label: 'Android_Chrome'
    })
  })
}
